import { FormattedMessage } from 'react-intl';

import Heading from '../../components/Heading/Heading.styled';
import { useCommon } from '../../context/CommonContext';
import Imppact from './components/Imppact/Imppact';
import SustainableActions from './components/SustainableActions/SustainableActions';
import TransportationAndHotelOffset from './components/TransportationAndHotelOffset/TransportationAndHotelOffset';
import TransportationOffset from './components/TransportationOffset/TransportationOffset';
import {
  ContentWrapperStyled,
  HomeWrapperStyled,
  ImppactSectionWrapperStyled,
  MainTitleStyled,
  MainTitleWrapperStyled,
  SectionWrapperStyled,
  SupHeadingStyled,
} from './HomePage.styled';

const HomePage: React.FC = () => {
  const {
    logoUrl,
    customerId,
    customerName,
    isMuralToTheme,
    isTransportDashboardType,
    isWayajCustomer,
  } = useCommon();

  return (
    <HomeWrapperStyled>
      {isMuralToTheme && (
        <SupHeadingStyled level={2} weight="normal">
          <FormattedMessage
            id="footprint.calculator.title"
            defaultMessage="Carbon Footprint Calculator"
          />
        </SupHeadingStyled>
      )}

      <MainTitleWrapperStyled>
        <MainTitleStyled level={2} align="center">
          <FormattedMessage id="home.mainTitle" defaultMessage="Practice Positive-Impact Travel" />
        </MainTitleStyled>

        {!isTransportDashboardType && (
          <Heading level={3} align="center">
            <FormattedMessage
              id="home.calculateAndOffsetSection.hotel.label"
              defaultMessage="Instantly Calculate & Offset Your Stay + Transportation"
            />
          </Heading>
        )}
      </MainTitleWrapperStyled>

      <ContentWrapperStyled>
        <ImppactSectionWrapperStyled>
          <Imppact
            logoUrl={logoUrl}
            isTransportType={isTransportDashboardType}
            isWayajCustomer={isWayajCustomer}
          />
        </ImppactSectionWrapperStyled>

        <SectionWrapperStyled>
          {isTransportDashboardType ? (
            <TransportationOffset isWayajCustomer={isWayajCustomer} />
          ) : (
            <TransportationAndHotelOffset customerId={customerId} customerName={customerName} />
          )}
        </SectionWrapperStyled>

        <SectionWrapperStyled>
          <SustainableActions
            isTransportType={isTransportDashboardType}
            isWayajCustomer={isWayajCustomer}
            customerId={customerId}
          />
        </SectionWrapperStyled>
      </ContentWrapperStyled>
    </HomeWrapperStyled>
  );
};

export default HomePage;
